import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>Gizlilik Politikasını</h2>
            <p><strong>Dreamhome gizlilik ilkesi</strong></p>
            <p><strong>Giriş</strong></p>
            <p>"Dreamehome" işi, size akıllı donanım cihazı kontrolü için bir platform (veya hizmet) sağlamak üzere Dreame
                Innovation Technology (Suzhou) Co., Ltd. ve bağlı kuruluşları (bundan böyle "biz" veya "Zimu" olarak
                anılacaktır)
                tarafından yürütülmektedir. ve yönetim hizmetleri). Kişisel bilgilerin sizin için önemini anlıyor ve anlıyoruz
                ve
                kişisel bilgilerinizin güvenliğini korumak için elimizden gelenin en iyisini yapacağız.</p>
            <p>Kişisel bilgilerinizi endüstri tarafından tanınan güvenlik standartlarına uygun olarak korumak için ilgili
                güvenlik
                koruma önlemlerini alacağız.</p>
            <p>Bu nedenle, ürünlerimizi (veya hizmetlerimizi) kullanmadan önce lütfen bu "Dreamehome Gizlilik Politikasını"
                dikkatlice okuyun ve anlayın.</p>
            <p>Reşit değilseniz, lütfen bu uygulamayı velinizin onayı ile kullanın ve ilgili uygulama hizmet şartlarını kabul
                edin.</p>
            <p>Bu gizlilik politikası, ihtiyaçlarınız göz önünde bulundurularak formüle edilmiştir.Kişisel bilgi toplama ve
                kullanma uygulamalarımızı tam olarak anlamanız ve aynı zamanda bize sağlanan kişisel bilgileri nihai olarak
                kontrol
                edebileceğinizden emin olmanız çok önemlidir. Bu gizlilik politikası, Uygulamamızı kullandığınızda bize
                sağladığınız
                bilgileri nasıl topladığımızı, kullandığımızı, ifşa ettiğimizi, işlediğimizi ve sakladığımızı şart koşar. Bu
                bilgileri kullanmak için kesinlikle bu gizlilik politikasına uyacağız.</p>
            <p>Bu gizlilik politikası aşağıdakileri anlamanıza yardımcı olacaktır:</p>
            <p>1. Hangi bilgileri topluyoruz ve nasıl kullanacağız?</p>
            <p>2. Çerezleri ve benzer teknolojileri nasıl kullanıyoruz?</p>
            <p>3. Kişisel bilgilerinizin işlenmesini, paylaşılmasını, aktarılmasını ve kamuya açıklanmasını nasıl emanet
                ediyoruz?
            </p>
            <p>4. Kişisel bilgilerinizi nasıl saklar ve koruruz?</p>
            <p>5. Haklarınız</p>
            <p>6. Sınır ötesi veri aktarımı</p>
            <p>7. Bize ulaşın</p>
            <p>8. Bu gizlilik politikası nasıl güncellenir?</p>
            <p>Ekli Tablo 1: Üçüncü taraf SDK'nın ayrıntıları</p>
            <p>Son olarak amacımız size en iyi kullanıcı deneyimini sunmaktır.Bu gizlilik politikası hakkında herhangi bir
                sorunuz
                varsa, özel bir gizlilik yönetimi departmanı ve personeli kurduk ve bu gizliliğin yedinci bölümünden onlarla
                iletişime geçebilirsiniz. politika. Ulusal politikalar ve yasaların gerektirdiği süreye göre yanıt vereceğiz.
                Yanıtımızdan memnun değilseniz, özellikle kişisel bilgi işleme davranışımızın meşru hak ve menfaatlerinize zarar
                verdiğini düşünüyorsanız, yetkili bir mahkemeye dava açmak, resmi bir düzenleyiciye şikayette bulunmak gibi
                harici
                kanallar aracılığıyla da çözebilirsiniz. ajans vb.</p>
            <p><strong>1. Hangi bilgileri topluyoruz ve bunları nasıl kullanıyoruz?</strong></p>
            <p>Kişisel bilgiler, elektronik olarak veya başka şekillerde kaydedilen ve bilgilerin kendisi aracılığıyla veya
                diğer
                bilgilerle ilişkilendirilerek belirli bir bireyi tanımlayabilen çeşitli verileri ifade eder.</p>
            <p>Kişisel hassas bilgiler, bir kez sızdırıldığında, yasa dışı olarak sağlandığında veya kötüye kullanıldığında
                kişisel ve mülk güvenliğini tehlikeye atabilecek, kolayca kişisel itibara, fiziksel ve zihinsel sağlık hasarına
                veya
                ayrımcı muameleye yol açabilecek kişisel bilgileri ifade eder. Kimlik numarası, kişisel biyometrik bilgiler,
                banka
                hesap numarası, mülk bilgileri, nerede olduğu, işlem bilgileri, 14 yaşından küçük çocukların kişisel bilgileri
                (dahil) dahil ancak bunlarla sınırlı değildir.</p>
            <p>Kişisel bilgileri toplamaktaki temel amacımız, size ürün ve/veya hizmet sunmak ve yürürlükteki yasalara,
                düzenlemelere ve diğer düzenleyici belgelere uymamızı sağlamaktır. Bu bilgileri sağlayıp sağlamamayı seçme
                hakkınız
                vardır, ancak çoğu durumda bunu sağlamazsanız size ilgili hizmetleri sağlayamayabiliriz ve sorunlarınıza yanıt
                veremeyebiliriz.</p>
            <p><strong>(1) Dreamhome'un temel hizmetleri tarafından kişisel bilgilerinizin toplanması ve işlenmesi</strong></p>
            <p><strong>(1) Dreamehome uygulaması, akıllı donanım cihazlarını bağlar ve yönetir</strong></p>
            <p>Size Dreamhome hizmetlerini sağlamak ve akıllı donanım cihazlarını güvenli bir şekilde bağlayıp yönetmenize
                olanak
                sağlamak için Wi-Fi bilgilerinizi, konum bilgilerinizi, oturum açma hesap bilgilerinizi, cep telefonuyla ilgili
                bilgileri, akıllı donanım cihazıyla ilgili bilgileri ve Find izlemenizi toplayabiliriz. hesap numarası ve akıllı
                donanım cihazı arasındaki ilişkili bilgiler. Bu bilgiler size hızlı bağlantı, bağlantı, yakındaki cihazların
                keşfi
                ve akıllı donanım cihazları için cihaz yönetimi işlevlerini sağlamak için kullanılacaktır. Yukarıdaki bilgiler
                aşağıda detaylı olarak listelenmiştir:</p>
            <p>Giriş hesabı bilgileri: chaimi hesabınızın kullanıcı adı, şifresi, takma adı, avatarı, e-postası, cep telefonu
                numarası. Bunlar arasında <strong>kullanıcı adı, parola, cep telefonu numarası ve e-posta hassas kişisel
                    bilgilerdir</strong>.Bu tür bilgileri toplamanın amacı, kullanıcının kimliğini doğrulamak için hesap
                sunucusunda
                oturum açmak ve Dreamhome hesabının bu bilgilere erişme iznini almaktır. sunucu. Girdiğiniz hesap kullanıcı adı
                ve
                oturum açma parolası kimlik doğrulama bilgileri şifrelenecek ve oturum açma kimlik doğrulaması için takip hesabı
                sunucusuna iletilecektir.</p>
            <p>Cep telefonuyla ilgili bilgiler: donanım cihazı kimliği (IMEI/OAID, Mac adresi, Android kimliği), telefon modeli,
                sistem sürüm bilgisi, sistem dili, telefonun ayarlandığı ülke veya bölge, telefon ekran boyutu ve çözünürlüğü,
                CPU
                ve görüntüleme cihazıyla ilgili bilgi. Bu tür bilgilerin toplanmasındaki amaç, Dreamhome uygulamasının akıllı
                donanım cihazlarına bağlanmasını sağlamaktır.</p>
            <p>Akıllı donanım cihazının bilgileri: akıllı donanım cihazının adı, modeli, sürümü, üreticisi, cihaz tanımlayıcısı,
                MAC adresi, IP adresi, cihaz çalışma durumu, özel nitelikler, ayar parametreleri, iş olayları ve cihaz kontrolü
                ve
                kullanım kayıtları. Bu tür bilgileri toplama amacımız, akıllı donanım cihazlarını bağlamak, cihazları kontrol
                etmek
                ve yönetmek, cihaz özelliklerini ve parametrelerini ayarlamak, cihazların çalışma durumlarını ve geçmişini
                görüntülemektir.</p>
            <p><strong>(2) Dreamehome uygulamasının ve akıllı donanım ekipmanının yükseltilmesi:</strong></p>
            <p>En yeni Dreamehome hizmetlerinden yararlanmaya devam edebilmeniz için Dreamehome uygulamanızın sürüm bilgilerini
                ve
                telefon modelini kullanarak size Dreamehome uygulaması için bir yükseltme hizmeti sağlayabiliriz. Aynı zamanda,
                hizmetin en son sürümünü (firmware sürümü dahil) kullanabilmenizi sağlamak için size akıllı donanım cihazlarının
                yükseltme işlevini sağlamak için bağlı akıllı donanım cihazlarınızın liste ve sürüm numarası bilgilerini
                toplayabiliriz. Dreamehome, yalnızca akıllı donanım aygıtları için yükseltme yolları sağlar.Akıllı donanım
                aygıtlarının aygıt yazılımı sürümü, akıllı donanım aygıtının üreticisi tarafından sağlanır ve sürüm kalitesi ve
                yükseltme sonuçlarından üretici sorumludur.</p>
            <p>Bu tür bilgileri sağlamazsanız, Dreamhome uygulamasının yeni sürümlerine ve akıllı donanım aygıtı ürün yazılımına
                yükseltme yapamazsınız.</p>
            <p><strong>(3) Çevrimiçi sorun geri bildirimi:</strong></p>
            <p>Dreamhome uygulamasında ve akıllı donanım cihazlarında oluşabilecek sorunları daha etkin bir şekilde çözmenize
                yardımcı olmak için size çevrimiçi sorun geri bildirimi kanalı sunuyoruz.Yukarıdaki işlevleri
                gerçekleştirebilmek
                için sizden aşağıdaki bilgileri toplamamız gerekiyor. : Dreamhome uygulaması ve cihaz günlüğü bilgileri, geri
                bildirim iletişim bilgileri ve sorun açıklaması, sorun fenomeni resimleri ve videoları. Uygulamaların ve
                cihazların
                günlük bilgileri, cihaz durumunu, sensör cihazları tarafından algılanan bilgileri, cihaz çalışma kayıtlarını,
                cihaz
                tanımlayıcılarını vb. içerecektir. Bu tür bilgileri toplamanın amacı, sorunun nedenini analiz etmek ve
                bulmaktır;
                irtibat kişinizi toplama amacı İade ziyaretini takip etmek, sorunun tamamen çözülüp çözülmediğini öğrenmek veya
                sizinle iletişime geçmek için gerekli diğer bilgileri ekleyebileceğinizi umuyorum.</p>
            <p>Kişisel bilgilerinizi şu şekillerde kullanacağız: kişisel bilgileri görüntülemek için değil, yalnızca geri
                bildirim
                sorunlarını konumlandırmak ve çözmek için ve bu bilgileri ticari reklamları zorlamak için kullanmamak. Bu tür
                bilgileri sağlamazsanız, bildirdiğiniz sorunları etkili bir şekilde bulup çözemezsiniz.</p>
            <p><strong>(2) Size temel Dreamhome hizmetleri sağlamak dışında kişisel bilgilerinizi topladığımız ve işlediğimiz
                koşullar</strong></p>
            <p>Dreamehome'un kişisel bilgilerinizi kullanacağı temel hizmetlere ek olarak, aşağıdaki ek işlevlerimiz de kişisel
                bilgilerinizi toplayabilir ve kullanabilir. Bu kişisel bilgileri sağlamazsanız, Dreamhome'un temel hizmetlerini
                kullanmaya devam edebilirsiniz, ancak size kolaylık sağlayabilecek bu ek özellikleri kullanamayabilirsiniz. Bu
                ek
                özellikler şunları içerir:</p>
            <p><strong>Kullanıcı deneyimi iyileştirme planı:</strong></p>
            <p>Kullanıcı deneyimini iyileştirmek için sizden aşağıdaki bilgileri toplamamız gerekiyor: Dreamehome'un günlükleri,
                şifrelenmiş anahtar işlem günlüklerini, olay günlüklerini, hata günlüklerini, iş olaylarını, Uygulama
                arabirimlerinin kullanımını vb. içerir ve hassas bilgileriniz günlüklere kaydedilmez.</p>
            <p>Kişisel bilgilerinizi aşağıdaki şekillerde kullanacağız: Yukarıdaki bilgiler otomatik olarak toplanır ve sunucuya
                yüklenir ve günlük bilgileri, cihazın çalışma durumunu teşhis etmek ve Uygulamanın kullanımını analiz etmek için
                analiz edilir.</p>
            <p>Bu bilgileri sağlamazsanız, Dreamhome kullanıcı deneyiminizi zamanında iyileştiremeyecek, ancak bu, hizmetin
                temel
                işlevlerini etkilemeyecektir.</p>
            <p><strong>(3) Kişisel bilgilerinizi üçüncü bir taraftan aldığımız koşullar</strong></p>
            <p>Yasaların izin verdiği bazı durumlarda, kişisel bilgilerinizi üçüncü bir taraftan alabiliriz. Örneğin:</p>
            <p>1. Yetkinize bağlı olarak, üçüncü şahıs hizmet sağlayıcılarından kişisel bilgilerinizi almamızı içeren üçüncü
                şahıs
                akıllı donanım ekipmanının yönetiminde üçüncü şahıs hizmet sağlayıcılarla işbirliği yapacağız. Üçüncü taraf
                cihaz
                yönetimi işinde, bir üçüncü taraf hesabını bağlamanız koşuluyla sizinle ilgili aşağıdaki kişisel bilgileri
                alacağız:
            </p>
            <p>Takma adınız ve avatarınız da dahil olmak üzere üçüncü taraf hesabının bilgileri Dreamhome uygulamasında
                görüntülemek için kullanılır;</p>
            <p>Cihaz tanımlayıcıları, MAC adresleri ve cihaz seri numaraları dahil olmak üzere cihaz ve ağ bilgileri, çalışmakta
                olan cihazı tanımlamak ve cihaz güvenlik kontrolünü gerçekleştirmek için kullanılır.</p>
            <p>İş yaptığımız sırada gerçekleştirmemiz gereken kişisel bilgi işleme faaliyetleri, üçüncü taraf hizmet
                sağlayıcılara
                kişisel bilgi sağlarken orijinal yetki ve rızanızın kapsamı dışındaysa, kişisel bilgilerinizi işlemeden önce
                açık
                rızanızı alacağız. Ayrıca, ilgili yasa ve yönetmeliklere sıkı sıkıya bağlı kalacağız ve üçüncü taraf hizmet
                sağlayıcıların sağladıkları bilgilerin yasallığını sağlamalarını zorunlu kılacağız.</p>
            <p><strong>(4) Kişisel olmayan bilgiler</strong></p>
            <p>Kullanıcı işlem davranışı (tıklamalar, sayfa atlamaları, tarama süresi dahil) gibi belirli bir hizmeti
                kullandığınızda oluşturulan istatistiksel veriler gibi belirli bir kişiyi tanımlayamayan diğer bilgileri de
                (yani
                kişisel bilgi olmayan bilgiler) toplayabiliriz. ) . Bu tür bilgileri toplamanın amacı, size sunduğumuz
                hizmetleri
                iyileştirmektir. Toplanan bilgilerin türü ve miktarı, ürünlerimizi ve/veya hizmetlerimizi nasıl kullandığınıza
                bağlıdır. Bu tür bilgileri, müşterilere daha yararlı bilgiler sağlamamıza ve web sitemizin, ürünlerimizin ve
                hizmetlerimizin en çok hangi bölümleriyle ilgilendiğini anlamamıza yardımcı olmak için toplayacağız, böylece
                hizmet
                arayüzünü optimize edebiliriz. Bu gizlilik politikasının amaçları doğrultusunda, toplu veriler kişisel olmayan
                bilgiler olarak değerlendirilir. Kişisel olmayan bilgileri kişisel bilgilerle birleştirirsek, bu tür bilgiler,
                birleşik kullanım süresi boyunca kişisel bilgiler olarak ele alınacaktır.</p>
            <p><strong>2. Çerezleri ve benzer teknolojileri nasıl kullanıyoruz?</strong></p>
            <p>Dreamhome'un normal çalışmasını sağlamak için cihazınızda Cookie adlı küçük bir veri dosyası saklayacağız.
                Çerezler
                genellikle tanımlayıcılar, site adları ve bazı sayılar ve karakterler içerir. Çerezlerin yardımıyla Dreamehome,
                web
                sitesi oturum açma hesap numaranızı, tercihlerinizi ve diğer verilerinizi saklayabilir.</p>
            <p>Çerezleri bu bildirimde belirtilenler dışında herhangi bir amaç için kullanmayacağız. Çerezleri tercihlerinize
                göre
                yönetebilir veya silebilirsiniz. Ancak bunu yaparsanız, bazı durumlarda Dreamehome'a ​​güvenli erişiminizi
                etkileyebilir ve Dreamehome'u her ziyaret ettiğinizde kullanıcı ayarlarını kişisel olarak değiştirmeniz
                gerekebilir.
            </p>
            <p><strong>3. Kişisel bilgilerinizin işlenmesini, paylaşılmasını, aktarılmasını ve kamuya açıklanmasını nasıl emanet
                ediyoruz?</strong></p>
            <p><strong>(1) Emanet edilen işlem</strong></p>
            <p>Normal şartlar altında, Chaimu, kişisel bilgilerinizi bizim adımıza işlemesi için başka şirketlere güvenebilir.
                Örneğin, sizinle bizim adımıza iletişim kuran, e-posta gönderen veya size teknik destek sağlayan şirketler, bu
                şirketler kişisel bilgilerinizi yalnızca bizim adımıza size hizmet sunmak için kullanabilir.</p>
            <p>Emanet edilen tarafla katı bir gizlilik sözleşmesi veya kişisel bilgi işleme maddesi imzalayacağız ve onlardan
                kişisel bilgileri bu gizlilik politikasına uygun olarak işlemelerini ve ilgili gizlilik ve güvenlik önlemlerini
                almalarını isteyeceğiz.</p>
            <p><strong>(2) Paylaşım</strong></p>
            <p>Normal şartlar altında, aşağıdaki durumlar dışında kişisel bilgilerinizi harici olarak paylaşmayacağız:</p>
            <p>1. Açık rızanızı aldıktan sonra, yetkilendirmeniz kapsamındaki bilgileri sizin belirlediğiniz üçüncü bir kişi ile
                paylaşacağız; Akıllı ev ürünlerinizin bilgi ve konfigürasyonlarını, akraba ve arkadaşlarınızın terminal
                cihazları
                üzerinden yazılım ve servisleri hızlı bir şekilde kullanmalarına yardımcı olmak için, isteğiniz üzerine akraba
                ve
                arkadaşlarınızla paylaşmayı içerir.</p>
            <p>2. Dreamhome hizmetinin hizmet içeriğinin bir kısmı üçüncü taraf hizmet sağlayıcılar tarafından sağlanmaktadır.Bu
                nedenle, web sitesi barındırma, veri analizi, ödeme ve kredi gibi bazı kişisel bilgilerinizi üçüncü taraf hizmet
                sağlayıcılara vermemiz gerekiyor. kart işleme, altyapı temini, BT Hizmetleri, müşteri destek hizmetleri, e-posta
                gönderme hizmetleri ve benzeri hizmetleri bize sunabilmelerini sağlamak için.</p>
            <p>3. Kişisel bilgilerinizin size doğrudan veya dolaylı olarak akıllı donanım cihazları ve/veya web sitemize ve
                hizmetlerimize erişmek ve bunları kullanmak için kullandığınız ağlar ve sistemler sağlayan müşterilere ve diğer
                iş
                ortaklarına ifşa edilmesi.</p>
            <p>4. İşimizin, varlıklarımızın veya stoklarımızın tamamının veya bir kısmının yeniden düzenlenmesi, birleşmesi,
                satışı, ortak girişimi, devri, devri veya başka şekilde elden çıkarılması durumunda (yukarıdaki herhangi bir
                iflas
                veya benzer prosedürlerle ilgili durumlar dahil ancak bunlarla sınırlı olmamak üzere) şirket veya diğer üçüncü
                taraflar kişisel bilgilerinizi ifşa eder. Bu durumda, mülkiyet değişikliği, kişisel bilgileri kullanmanın yeni
                yollarının uyumsuzluğu ve kişisel bilgilerin seçimi hakkında e-posta ve/veya web sitemiz aracılığıyla net bir
                bildirim alacaksınız.</p>
            <p>5. Gerekli veya uygun gördüğümüzde: (a) Geçerli yasalara ve düzenlemelere uyun; (b) Yasal prosedürlere uyun; (c)
                Yaşadığınız ülke/bölge dışındaki kamu kurumları ve devlet yetkilileri dahil olmak üzere, kamu kurumlarının ve
                devlet
                kurumlarının gereksinimlerine yanıt verin; (d) Şartlarımızı ve koşullarımızı yerine getirin; (e)
                Faaliyetlerimizi,
                işimizi ve sistemlerimizi koruyun; (f) Bizim ve/veya siz dahil diğer kullanıcıların haklarını, gizliliğini,
                güvenliğini veya mülkiyetini koruyun; ve (g) mevcut çareleri aramak veya sağlamamız gerekebilecek zararları
                sınırlamak.</p>
            <p>6. Kişisel bilgilerinizin düzenli olarak ticari faaliyetlerde bulunmak amacıyla şirket iştiraklerine veya bağlı
                şirketlerine ifşa edilmesi.</p>
            <p>7. Uygulama programı arayüzü (API) ve yazılım aracı geliştirme kiti (SDK) aracılığıyla gerekli verileri üçüncü
                taraflarla paylaşacağız.Üçüncü taraf SDK'nın farklı sürümleri, genellikle üçüncü taraf hesap oturum açma türü
                dahil
                olmak üzere farklı olacaktır, paylaşım türü, Üçüncü taraf ödemesi, satıcı bildirimi, istatistikler vb. için
                üçüncü
                taraflar üzerinde sıkı güvenlik denetimleri gerçekleştireceğiz ve veri koruma önlemleri üzerinde anlaşacağız. Ek
                1,
                erişim yetkisi verdiğimiz üçüncü taraf SDK'nın ayrıntılarıdır, lütfen dikkatlice okuyunuz. Gizlilik politikamız,
                üçüncü şahıslar tarafından sağlanan ürünler veya hizmetler için geçerli değildir. Bu ürünleri veya hizmetleri
                kullandığınızda, bilgilerinizi de toplayabilirsiniz. Bu nedenle, tıpkı politikamızı okumak gibi, üçüncü
                şahısların
                gizlilik politikasını okumak için zaman ayırmanızı şiddetle tavsiye ederiz. Üçüncü tarafların sizden
                topladıkları
                kişisel bilgileri nasıl kullandıklarından sorumlu değiliz ve kullanımlarını kontrol edemeyiz. Gizlilik
                politikamız,
                hizmetimiz aracılığıyla bağlantı verilen diğer web siteleri için geçerli değildir. Bağlantılı web sitesiyle
                etkileşiminizi bağımsız olarak değerlendirmeniz gerekir. Üçüncü taraf sayfasına ilk kez girmeden önce, üçüncü
                taraf
                hizmet sağlayıcı size ilgili sözleşmeleri ve gizlilik bildirimlerini gösterecektir.Lütfen bu sözleşmeleri ve
                gizlilik bildirimlerini dikkatlice okuyunuz.</p>
            <p><strong>(3) Aktarma</strong></p>
            <p>Chaimi, kişisel bilgilerinizi aşağıdaki durumlar dışında hiçbir şirkete, kuruluşa veya bireye aktarmayacaktır:
            </p>
            <p>1. Açık rıza ile aktarım: Açık rızanızı aldıktan sonra, kişisel bilgilerinizi diğer taraflara aktaracağız;</p>
            <p>2. Birleşme, devralma veya iflas tasfiyesi söz konusu olduğunda, kişisel bilgilerin transferini içeriyorsa,
                kişisel
                bilgilerinizi elinde bulunduran yeni şirket veya kuruluşun bu beyana bağlı kalmasını talep edeceğiz, aksi
                takdirde
                şirket veya şirketten veya yeniden göndermek için kuruluş Yetki ve onay talep ediyorsunuz.</p>
            <p><strong>(4) Kamuya açıklama</strong></p>
            <p>Kişisel bilgilerinizi yalnızca aşağıdaki durumlarda kamuya açıklayacağız:</p>
            <p>1. Açık rızanızı aldıktan sonra;</p>
            <p>2. Yasaya dayalı açıklama: Kişisel bilgilerinizi yasalara uygun olarak veya yasal prosedürlere, davalara veya
                devlet yetkililerinin zorunlu gereksinimlerine dayanarak kamuya açıklayabiliriz.</p>
            <p><strong>4. Kişisel bilgilerinizi nasıl saklar ve koruruz?</strong></p>
            <p>Kişisel bilgileri, bu gizlilik politikasında açıklanan bilgi toplama amacıyla veya geçerli yasal gerekliliklere
                uygun olarak gerekli olan süre boyunca saklarız. Toplama amacını tamamladıktan sonra veya silme veya iptal
                başvurunuzu onayladıktan sonra veya ilgili ürün veya hizmetin işleyişini sonlandırdıktan sonra, onu alıkoymayı
                durdurur ve siler veya anonimleştiririz. Kamu yararı, bilimsel, tarihsel araştırma veya istatistiksel amaçlar
                içinse, daha fazla veri işlemenin orijinal toplama amacı ile hiçbir ilgisi olmasa bile, geçerli yasalara dayalı
                olarak ilgili verileri saklamaya devam edeceğiz.</p>
            <p>Dreamhome işinde, kişisel verilerinizin belirli saklama süresi aşağıdaki gibidir:</p>
            <p>Dreamhome uygulamasında yerel olarak depolanan veriler için Dreamhome uygulamasını kaldırdığınızda veya Dreamhome
                uygulama verilerini temizlediğinizde, depolanan tüm veriler hemen silinecektir.</p>
            <p>Dreamhome akıllı donanım cihazları ve sunucuda depolanan iş verileri için, akıllı donanım cihazını sildiğinizde,
                Dreamhome gizlilik politikasını kabul etmeyi reddettiğinizde ve Dreamhome hizmetini kullanmayı bıraktığınızda,
                depolanan tüm veriler hemen silinecektir.</p>
            <p>Sunucuda depolanan iş günlükleri, istatistiksel veriler ve geçmiş kayıtlar için, zaman zaman sunucu verilerini
                temizlediğimizde bunları sileriz ve veri saklama süresi genellikle 2 yılı geçmez.</p>
            <p>Ayrıca, ürünlerimizin veya hizmetlerimizin çalışması sona erdiğinde size anlık bildirimler, duyurular vb.
                şeklinde
                bildirimde bulunacağız ve makul bir süre içinde kişisel bilgilerinizi silecek veya anonimleştirme
                gerçekleştireceğiz.</p>
            <p><strong>5. Haklarınız</strong></p>
            <p><strong>(1) Kişisel bilgilerinize erişin, bunları düzeltin ve silin</strong></p>
            <p>Başvurduğunuz ülke veya bölgenin yasa ve yönetmeliklerine göre, hakkınızda tuttuğumuz her türlü kişisel bilgiye
                (bundan sonra talep olarak anılacaktır) erişme, düzeltme ve silme talebinde bulunma hakkınız vardır. Lütfen bize
                yazın veya Dreamhome'u ziyaret ederek bizimle iletişime geçin. Çoğu yasa, kişisel bilgi konularının taleplerinin
                belirli gereksinimlere uymasını gerektirir.Bu gizlilik politikası, taleplerinizin aşağıdaki koşullara uymasını
                gerektirir:</p>
            <p>Özel talep kanalımız aracılığıyla ve bilgi güvenliğinizi korumak adına talebiniz yazılı olmalıdır (yerel yasa
                sözlü
                bir başvuruyu açıkça tanımıyorsa);</p>
            <p>Kimliğinizi doğrulayabilmemiz ve talepte bulunan kişinin talep edilen bilgilerin konusu veya yasal olarak yetkili
                bir kişi olduğundan emin olabilmemiz için yeterli bilgiyi sağlayın;</p>
            <p>Talebinizi işleme koyabileceğimizi doğrulamak için yeterli bilgiyi edindikten sonra, geçerli veri koruma
                yasalarında belirtilen süre içinde talebinize yanıt vereceğiz. Özellikle:</p>
            <p>Talebinize ve geçerli yasa ve yönetmeliklere dayanarak, topladığımız ve işlediğimiz kişisel bilgilerinizin bir
                kaydını ücretsiz olarak sağlayabiliriz.İlgili bilgiler için başka taleplerde bulunursanız, ilgili geçerli
                yasalara
                dayanabilir ve fiili yönetim maliyetini birleştirebiliriz makul bir ücret talep eder.</p>
            <p>Hakkınızda tuttuğumuz herhangi bir bilginin yanlış veya eksik olduğuna inanıyorsanız, kişisel bilgilerinizi
                kullanım amacına göre düzeltmeyi veya tamamlamayı talep edebilirsiniz.</p>
            <p>Yürürlükteki yasa ve yönetmeliklerinize göre, kişisel verilerinizi silmemizi talep etme hakkınız olabilir. Silme
                talebinizi değerlendireceğiz ve ilgili düzenlemelere uyulması halinde, bununla başa çıkmak için teknik araçlar
                dahil
                ilgili adımları atacağız. İlgili bilgileri silmenize yardımcı olduğumuzda, yürürlükteki yasalar ve güvenlik
                teknolojileri nedeniyle, ilgili bilgileri yedekleme sisteminden hemen silemeyebiliriz.Kişisel bilgilerinizi
                güvenli
                bir şekilde saklayacağız ve sonraki işlemlerden yalıtacağız. Yedekleme temizlenene veya anonimlik sağlanana
                kadar.
                Örneğin "Çin Halk Cumhuriyeti E-Ticaret Kanunu"na göre ürün ve hizmet bilgileriniz ile işlem bilgileriniz
                işlemin
                tamamlandığı tarihten itibaren en az üç yıl süreyle saklanmaktadır.</p>
            <p>Önemli olmayan/dolaşık tekrarlayan talepleri, başkalarının gizliliğine zarar veren talepleri, son derece gerçekçi
                olmayan talepleri, orantısız teknik çalışma taleplerini ve yerel yasalara göre verilmesi gerekmeyen talepleri
                işlemeyi reddetme hakkımız vardır. daha önce kamuya açıklanmış ise gizli tutulmaktadır.Verilen bilgiler şartlar
                dahilindedir. Verileri silme veya verilere erişme talebinin belirli yönlerinin, yukarıda belirtilen
                dolandırıcılık
                karşıtı ve güvenlik amaçları için verileri yasal olarak kullanmamızı engelleyebileceğini düşünürsek, bunu da
                reddedebiliriz.</p>
            <p><strong>(2) Rızanın geri alınması</strong></p>
            <p>Sahip olduğumuz veya kontrol ettiğimiz kişisel bilgilerinizi toplamak, kullanmak ve/veya ifşa etmek dahil olmak
                üzere bir talep göndererek onayınızı iptal edebilirsiniz. Kullandığınız belirli hizmetlere göre, bu gizlilik
                politikasının 7. bölümündeki iletişim bilgileri aracılığıyla ilgili işlemler için bizimle iletişime
                geçebilirsiniz.
                Talebinizi, talebinizi yaptıktan sonra makul bir süre içinde işleme koyacağız ve talebinize uygun olarak artık
                kişisel bilgilerinizi toplamayacağız, kullanmayacağız ve/veya açıklamayacağız.</p>
            <p>Bilgi işleme yetkinizin kapsamına bağlı olarak, onayınızı geri çekmenizin Dreamehome hizmetlerinden veya akıllı
                donanım ürünlerinden yararlanamamanıza neden olabileceğini lütfen unutmayın. Ancak, onayınızı veya yetkinizi
                geri
                alma kararınız, kişisel bilgilerinizin yetkinize dayalı olarak önceki işlenmesini etkilemeyecektir.</p>
            <p>Kullanıcı deneyimi geliştirme programından çıkmak için değişiklik yapmak için Dreamhome sayfasına girerek veya
                onayın geri çekilmesini talep ederek bu kişisel bilgilerin kullanımına ilişkin onayınızı geri çekebilirsiniz.
            </p>
            <p><strong>(3) Dreamhome hesabından çıkış yapın</strong></p>
            <p>"Benim"-"Hesap Ayarları"-"Çıkış Hesabı"nı ziyaret ederek Dreamhome hesabından çıkış yapabilirsiniz. Dreamehome
                hesabınızı iptal etmek isterseniz, Dreamhome hesabınızı iptal etme işlemi, Dreamehome'u ve tüm akıllı donanım
                ürün
                ve hizmetlerini kullanmanızı engelleyecektir.Lütfen dikkatli ilerleyin. Sizin veya başkalarının meşru hak ve
                menfaatlerini korumak için, Dreamhome'un akıllı donanım ürünlerini ve hizmetlerini kullanımınıza bağlı olarak
                iptal
                talebinizi destekleyip desteklemeyeceğimizi belirleyeceğiz.</p>
            <p><strong>6. Sınır ötesi veri aktarımı</strong></p>
            <p>Tüm dünyadaki kaynaklar ve sunucular aracılığıyla ürün veya hizmet sağladığımız için, bu, sizin yetki ve
                onayınızı
                aldıktan sonra, kişisel bilgilerinizin ürünü veya hizmeti kullandığınız veya Aldığınız ülkenin/bölgenin
                denizaşırı
                yargı yetkisine aktarılabileceği anlamına gelir. Bu yetki alanlarından ziyaretler. Bilgilerinizin
                aktarılabileceği
                ülkenin/bölgenin veri koruma önlemleri ve diğer yasaları, ülkeniz/bölgeniz kadar kapsamlı olmayabilir. Bu gibi
                durumlarda, kişisel bilgilerinizin korunmaya devam etmesini sağlamak için her bir yargı alanının geçerli
                yasalarına
                uygun olarak uygun ve yasal önlemleri alacağız.</p>
            <p>Özel not:</p>
            <p>Avrupa Ekonomik Alanı'nda (AEA) ikamet ediyorsanız ve kişisel bilgileriniz AEA dışına aktarılıyorsa: kişisel
                bilgilerinizi Avrupa Komisyonu'nun yeterli düzeyde koruma sağlayabileceğini belirlediği bir alanda işleyeceğiz;
                veya
                Avrupa Komisyonu'nun standart sözleşme maddeleri gibi geçerli iletim mekanizmalarına uygun olarak iletim dahil
                olmak
                üzere, kişisel bilgilerinizi korumak için uygun koruyucu önlemleri uygulayın.</p>
            <p><strong>7. Bize Ulaşın</strong></p>
            <p>Bu gizlilik politikası hakkında herhangi bir yorumunuz veya sorunuz varsa veya kişisel bilgilerinizi toplamamız,
                kullanmamız veya ifşa etmemiz hakkında herhangi bir sorunuz varsa, lütfen aşağıdaki adresten veya "Benim" -
                "Takip
                ve Geri Bildirim" bölümünü ziyaret ederek bizimle iletişime geçin, ve "Gizlilik Politikası"ndan bahsedin.
                Kişisel
                bilgilerle ilgili hak taleplerinize, sorun danışmalarınıza vb. yanıt olarak, sorunlarınızı çözmek için
                profesyonel
                bir ekibimiz var. Sorunuzun kendisi daha önemli konuları içeriyorsa, sizden daha fazla bilgi vermenizi
                isteyebiliriz. Aldığınız yanıttan memnun değilseniz, şikayetinizi yargı bölgenizdeki ilgili denetim makamına
                iletebilirsiniz. Bize danışırsanız, mevcut durumunuza göre olası şikayet kanalları hakkında size bilgi
                vereceğiz.
            </p>
            <p><strong>E-posta adresi</strong></p>
            <ul>
                <li>Çin'de iletişim: <a className="page"
                    href="mailto:privacy@dreame.tech">privacy@dreame.tech</a></li>
                <li>Singapur DPO iletişim bilgileri: <a className="page"
                    href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a></li>
                <li>AB temsilcisinin iletişim bilgileri: temsilci.dreame@herrero.es</li>
            </ul>
            <p>İletişim numarası: 400-875-9511</p>
            <p>Web sitesi: <a className="page"
                href="https://www.dreametech.com">https://www.dreametech.com</a></p>
            <p><strong>8. Bu gizlilik politikası nasıl güncellenir?</strong></p>
            <p>Zhuimi, bu politikayı zamanında güncelleme hakkını saklı tutar.Politika değiştiğinde, değişen politikayı bir
                açılır
                pencere veya diğer önemli yollarla size göstereceğiz. Yalnızca onayınızı aldıktan sonra, kişisel bilgilerinizi
                güncellenen politikaya uygun olarak toplayacak, kullanacak ve saklayacağız.</p>
            <p>Bu politika, güncelleme tarihinden itibaren geçerlidir.</p>
            <p>Son güncelleme: 28 Ağustos 2021</p>
            <p><strong>Ekli Tablo 1: Üçüncü taraf SDK'nın ayrıntıları</strong></p>
            <p>*Size daha profesyonel ve güvenli temel ve ek işlevsel hizmetler sunmak için Dreamhome, üçüncü taraf SDK
                ürünlerine
                erişecektir. Şu anda Dreamhome'da bulunan üçüncü taraf SDK ürünleri aşağıdaki gibi açıklanmıştır:</p>
            <div className='tableStyle'>
                <table>
                    <tr>
                        <td>
                            <p>SDK hizmeti</p>
                        </td>
                        <td>
                            <p>Özel fonksiyon</p>
                        </td>
                        <td>
                            <p>Bilgi alımı</p>
                        </td>
                        <td>
                            <p className="page">Üçüncü taraf gizlilik politikası</p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Youmeng İstatistiksel Analiz SDK'sı</p>
                        </td>
                        <td>
                            <p>İstatistiksel analiz</p>
                        </td>
                        <td>
                            <p>Cihaz tanımlayıcısı (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, SIM kart IMSI bilgileri), coğrafi konum
                            </p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Umeng News Push SDK'sı</p>
                        </td>
                        <td>
                            <p>Bilgi Tavsiye Etme</p>
                        </td>
                        <td>
                            <p>Cihaz tanımlayıcısı (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, SIM kart IMSI bilgileri), coğrafi konum
                            </p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Youmeng Sosyal Paylaşım SDK'sı</p>
                        </td>
                        <td>
                            <p>Üçüncü taraf paylaşımı</p>
                        </td>
                        <td>
                            <p>Cihaz tanımlayıcısı (IMEI/Mac/android ID/IDFA/OPENUDID/GUID, SIM kart IMSI bilgileri), coğrafi konum
                            </p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Agora SDK'sı</p>
                        </td>
                        <td>
                            <p>Lianmai, video akışı</p>
                        </td>
                        <td>
                            <p>Cihaz bilgisi, ağ durumu, kamera, mikrofon, okuma ve yazma depolama alanı</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Huawei SDK’yi tavsiye ediyor</p>
                        </td>
                        <td>
                            <p>Tavsiye Et</p>
                        </td>
                        <td>
                            <p>Cihaz tanımlama bilgileri</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Xiaomi SDK’yi tavsiye ediyor</p>
                        </td>
                        <td>
                            <p>Tavsiye Et</p>
                        </td>
                        <td>
                            <p>Cihaz tanımlama bilgileri, cihaz modeli, ağ türü, cihaz depolama, cihaz çalışan işlem bilgileri,
                                uygulama
                                sürümü, SDK sürümü</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>OPPO SDK’yi tavsiye ediyor</p>
                        </td>
                        <td>
                            <p>Tavsiye Et</p>
                        </td>
                        <td>
                            <p>Cihaz tanımlama bilgileri</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>VIVO SDK’yi tavsiye ediyor</p>
                        </td>
                        <td>
                            <p>Tavsiye Et</p>
                        </td>
                        <td>
                            <p>Cihaz tanımlama bilgileri</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Wechat SDK</p>
                        </td>
                        <td>
                            <p>WeChat üçüncü taraf girişi, WeChat paylaşımı</p>
                        </td>
                        <td>
                            <p>Cihaz tanımlama bilgileri, ağ bilgileri</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>QQ SDK</p>
                        </td>
                        <td>
                            <p>Paylaş</p>
                        </td>
                        <td>
                            <p>Cihaz tanımlama bilgileri, ağ bilgileri</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Weibo SDK</p>
                        </td>
                        <td>
                            <p>Weibo üçüncü taraf girişi, Weibo paylaşımı</p>
                        </td>
                        <td>
                            <p>Cihaz tanımlama bilgileri, ağ bilgileri</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p>Apple Kimliği SDK</p>
                        </td>
                        <td>
                            <p>Apple kimliği ile giriş yapın</p>
                        </td>
                        <td>
                            <p>Apple Kimliği</p>
                        </td>
                        <td>
                            <p><a className="page"
                                href="https://www.Apple.com/legal/privacy/szh/">https://www.Apple.com/legal/privacy/szh/</a></p>
                        </td>
                    </tr>
                </table>
            </div>
            <div className='height'></div>
        </div>
    )
}

export default PricacyPolicy